<template>
<div class="c-single-car-payments__wrapper -single-used" v-if="loaded">
    <div class="c-single-car-payments">
        <div class="c-single-car-payments__title__wrapper">
            <h2 class="c-single-car-payments__title">Estimez vos paiements</h2>
        </div>
        <div class="c-single-car-payments__discount__wrapper" v-if="currentRebate">
            <span class="c-single-car-payments__discount">Rabais de {{ cash(currentRebate) }}</span>
            <svgIco icon='price-tag-fill'/>
        </div>
        
        <div class="c-single-car-payments__toggle__wrapper">
            <div class="c-single-car-payments__toggle">
                <button v-if="hasLease" class="c-single-car-payments__toggle__button js-single-car-payments-button-1" 
                    :class="{'-is-active': show=='lease'}" 
                     @click="show='lease'; expanded = true">
                    {{ cents(leaseTotal) }}
                </button>
                <button v-if="hasFinance" class="c-single-car-payments__toggle__button js-single-car-payments-button-1" 
                    :class="{'-is-active': show=='finance'}" 
                    @click="show='finance'; expanded = true">
                    {{ cents(financeTotal) }}
                </button>
                <button class="c-single-car-payments__toggle__button js-single-car-payments-button-1" 
                    :class="{'-is-active': show=='cash'}" 
                    @click="show='cash'; expanded = true">
                    {{ cash(cashTotal) }}
                </button>
            </div>
            <div class="c-single-car-payments__toggle__label__wrapper">
                <span v-if="hasLease" class="c-single-car-payments__toggle__label js-single-car-payments-label-1" data-active="location-1" :class="{'-is-active': show=='lease'}">Location</span>
                <span v-if="hasFinance" class="c-single-car-payments__toggle__label js-single-car-payments-label-1" data-active="financement-1" :class="{'-is-active': show=='finance'}">Financement</span>
                <span class="c-single-car-payments__toggle__label js-single-car-payments-label-1" data-active="comptant-1" :class="{'-is-active': show=='cash'}">Comptant</span>
            </div>
        </div>
    </div>
    <div class="c-single-car-payments__expend-boxes" :class="{'-is-expend': expanded}">
        <div class="c-single-car-payments__expend-boxes__inner">

            <!-- Location -->
            <div v-if="hasLease" class="c-single-car-payments__expend__location js-single-car-item-1" data-item-active="location-1" :class="{'-is-active': show=='lease'}">
                <div class="c-single-car-payments-content__select -location-select">
                    <div class="o-select__wrap">
                        <select class="o-select o-select-simple" v-model="term">
                            <option value="weekly">Par semaine</option>
                            <option value="biweekly">Aux 2 semaines</option>
                            <option value="monthly">Mensuel</option>
                        </select>
                    </div>
                    <div class="o-select__wrap">
                        <select class="o-select o-select-simple" v-model="leaseMonths">
                            <option v-for="item in leaseOptions" :value="item.months" :key="item.months">{{ item.months }} mois / {{ pct(item.rate) }}</option>
                        </select>
                    </div>
                    <div class="o-select__wrap">
                        <select class="o-select o-select-simple" v-model="mileage">
                            <option v-for="item in leaseMileage" :value="item.value" :key="item.value">{{ item.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="c-single-car-comptant c-single-car-neuf">
                    <!-- prix du véhicule -->
                    <div class="c-single-car-neuf__row">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': leasePriceExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="leasePriceExpanded = !leasePriceExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Prix du véhicule</span>
                                    </div>
                                    <span class="c-single-car-payments-content__price">{{cents(leaseLines.priceTotal)}}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                            <template v-for="(line, index) in leaseLines.prices" :key="index">
                                                <div class="c-single-car-price__table__row" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Rabais -->
                    <div class="c-single-car-neuf__row" v-if="leaseLines.discountTotal">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': leaseDiscountExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="leaseDiscountExpanded = !leaseDiscountExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Rabais</span>
                                    </div>
                                    <span class="c-single-car-payments-content__discount">-{{ cents(leaseLines.discountTotal) }}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                             <template v-for="(line, index) in leaseLines.discounts" :key="index">
                                                <div class="c-single-car-price__table__row" :class="{'-alt': line.value < 0}" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                            <div v-if="leaseLines.hasEcoRebate" class="c-single-car-price__table__info">
                                                <h4 class="c-single-car-price__table__info__title">Pourquoi retenons-nous les taxes?</h4>
                                                <p>Le rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <span class="c-single-car-payments-content__label">Ajoutez une  valeur d’échange&nbsp;:</span>
                        <span class="o-input__wrap">
                            <input type="text" class="o-input o-input-smaller" v-model.number="exchange" placeholder="-0,00 $">
                        </span>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <div class="c-single-car-payments-content__taxes">
                            <div class="c-single-car-payments-content__taxes__radio">
                                <label class="c-single-car-payments-content__taxes__label">
                                    <input type="checkbox" name="checkbox" value="1" v-model="includeTaxes">
                                    <span>Inclure les taxes</span>
                                </label>
                            </div>
                            <div class="c-single-car-payments-content__taxes__row">
                                <span class="c-single-car-payments-content__label">TPS :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(leaseTPS) }}</span>
                                <span class="c-single-car-payments-content__label">TVQ :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(leaseTVQ) }}</span>
                            </div>
                        </div>
                    </div>
                     <div class="c-single-car-payments-content__row">
                        <span class="c-single-car-payments-content__label">Ajoutez un versement initial&nbsp;:</span>
                        <span class="o-input__wrap">
                            <input type="text" class="o-input o-input-smaller" v-model.number="initial" placeholder="-0,00 $">
                        </span>
                    </div>
                    
                    <div class="c-single-car-payments-content__row -total">
                        <span class="c-single-car-payments-content__label">Votre paiement par {{ termText }}</span>
                        <span class="c-single-car-payments-content__price">{{cents(leaseTotal)}}</span>
                    </div>
                </div>
                <Note />

                <!-- Programmes admissibles -->
                <Programs type="finance" :row="currentRow" :selectedPrograms="selectedPrograms" />
            </div>

            <!-- Financement -->
            <div v-if="hasFinance" class="c-single-car-payments__expend__financement js-single-car-item-1" data-item-active="financement-1" :class="{'-is-active':  show=='finance'}">
                <div class="c-single-car-payments-content__select">
                    <div class="o-select__wrap">
                        <select class="o-select o-select-simple" v-model="term">
                            <option value="weekly">Par semaine</option>
                            <option value="biweekly">Aux 2 semaines</option>
                            <option value="monthly">Mensuel</option>
                        </select>
                    </div>
                    <div class="o-select__wrap">
                        <select class="o-select o-select-simple" v-model="financeMonths">
                            <option v-for="item in financeOptions" :value="item.months" :key="item.months">{{ item.months }} mois / {{ pct(item.rate) }}</option>
                        </select>
                    </div>
                </div>
                
                <div class="c-single-car-comptant c-single-car-neuf">
                    <!-- prix du véhicule -->
                    <div class="c-single-car-neuf__row">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': financePriceExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="financePriceExpanded = !financePriceExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Prix du véhicule</span>
                                    </div>
                                    <span class="c-single-car-payments-content__price">{{cents(financeLines.priceTotal)}}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                            <template v-for="(line, index) in financeLines.prices" :key="index">
                                                <div class="c-single-car-price__table__row" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Rabais -->
                    <div class="c-single-car-neuf__row" v-if="financeLines.discountTotal">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': financeDiscountExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="financeDiscountExpanded = !financeDiscountExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Rabais</span>
                                    </div>
                                    <span class="c-single-car-payments-content__discount">-{{ cents(financeLines.discountTotal) }}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                             <template v-for="(line, index) in financeLines.discounts" :key="index">
                                                <div class="c-single-car-price__table__row" :class="{'-alt': line.value < 0}" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                            <div v-if="financeLines.hasEcoRebate" class="c-single-car-price__table__info">
                                                <h4 class="c-single-car-price__table__info__title">Pourquoi retenons-nous les taxes?</h4>
                                                <p>Ce rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <span class="c-single-car-payments-content__label">Ajoutez une  valeur d’échange&nbsp;:</span>
                        <span class="o-input__wrap">
                            <input type="text" class="o-input o-input-smaller" v-model.number="exchange" placeholder="-0,00 $">
                        </span>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <div class="c-single-car-payments-content__taxes">
                            <div class="c-single-car-payments-content__taxes__radio">
                                <label class="c-single-car-payments-content__taxes__label">
                                    <input type="checkbox" name="checkbox" value="1" v-model="includeTaxes">
                                    <span>Inclure les taxes</span>
                                </label>
                            </div>
                            <div class="c-single-car-payments-content__taxes__row">
                                <span class="c-single-car-payments-content__label">TPS :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(financeTPS) }}</span>
                                <span class="c-single-car-payments-content__label">TVQ :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(financeTVQ) }}</span>
                            </div>
                        </div>
                    </div>
                     <div class="c-single-car-payments-content__row">
                        <span class="c-single-car-payments-content__label">Ajoutez un versement initial&nbsp;:</span>
                        <span class="o-input__wrap">
                            <input type="text" class="o-input o-input-smaller" v-model.number="initial" placeholder="-0,00 $">
                        </span>
                    </div>
                    
                    <div class="c-single-car-payments-content__row -total">
                        <span class="c-single-car-payments-content__label">Votre paiement par {{ termText }}</span>
                        <span class="c-single-car-payments-content__price">{{ cents(financeTotal) }}</span>
                    </div>
                </div>
                <Note />

                <!-- Programmes admissibles -->
                <Programs type="finance" :row="currentRow" :selectedPrograms="selectedPrograms" />
            </div>

            <!-- Comptant -->
            <div class="c-single-car-payments__expend__comptant js-single-car-item-1" data-item-active="comptant-1"  :class="{'-is-active': show=='cash'}">
                <div class="c-single-car-payments-content__select">
                    
                </div>
                
                <div class="c-single-car-comptant c-single-car-neuf">
                    <!-- prix du véhicule -->
                    <div class="c-single-car-neuf__row">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': cashPriceExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="cashPriceExpanded = !cashPriceExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Prix du véhicule</span>
                                    </div>
                                    <span class="c-single-car-payments-content__price">{{cents(cashLines.priceTotal)}}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                            <template v-for="(line, index) in cashLines.prices" :key="index">
                                                <div class="c-single-car-price__table__row" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Rabais -->
                    <div class="c-single-car-neuf__row" v-if="cashLines.discountTotal">
                        <div class="c-single-car-row__accordion">
                            <div class="c-single-car-row__accordion__section" :class="{'-is-active': cashDiscountExpanded}">
                                <div class="c-single-car-row__accordion__header" @click="cashDiscountExpanded = !cashDiscountExpanded">
                                    <div class="c-single-car-row__accordion__header__inner">
                                        <div class="c-single-car-row__icon">
                                            <svgIco icon='more' class='-icon-more'/>
                                            <svgIco icon='less' class='-icon-less'/>
                                        </div>
                                        <span class="c-single-car-row__accordion__header__label">Rabais</span>
                                    </div>
                                    <span class="c-single-car-payments-content__discount">-{{ cents(cashLines.discountTotal) }}</span>
                                </div>
                                <div class="c-single-car-row__accordion__content">
                                    <div class="c-single-car-row__accordion__inner">
                                        <div class="c-single-car-price__table">
                                             <template v-for="(line, index) in cashLines.discounts" :key="index">
                                                <div class="c-single-car-price__table__row" :class="{'-alt': line.value < 0}" v-if="line.value">
                                                    <span class="">{{line.label}}</span>
                                                    <span class="">{{cents(line.value)}}</span>
                                                </div>
                                            </template>
                                            <div v-if="cashLines.hasEcoRebate" class="c-single-car-price__table__info">
                                                <h4 class="c-single-car-price__table__info__title">Pourquoi retenons-nous les taxes?</h4>
                                                <p>Le rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <span class="c-single-car-payments-content__label">Ajoutez une  valeur d’échange&nbsp;:</span>
                        <span class="o-input__wrap">
                            <input type="text" class="o-input o-input-smaller" v-model.number="exchange" placeholder="-0,00 $">
                        </span>
                    </div>
                    <div class="c-single-car-payments-content__row">
                        <div class="c-single-car-payments-content__taxes">
                            <div class="c-single-car-payments-content__taxes__radio">
                                <label class="c-single-car-payments-content__taxes__label">
                                    <input type="checkbox" name="checkbox" value="1" v-model="includeTaxes">
                                    <span>Inclure les taxes</span>
                                </label>
                            </div>
                            <div class="c-single-car-payments-content__taxes__row">
                                <span class="c-single-car-payments-content__label">TPS :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(cashTPS) }}</span>
                                <span class="c-single-car-payments-content__label">TVQ :</span>
                                <span class="c-single-car-payments-content__price">{{ cents(cashTVQ) }}</span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="c-single-car-payments-content__row -total">
                        <span class="c-single-car-payments-content__label">Votre paiement</span>
                        <span class="c-single-car-payments-content__price">{{cents(cashTotal)}}</span>
                    </div>
                </div>
                <Note />

                <!-- Programmes admissibles -->
                <Programs type="cash" :row="currentRow" :selectedPrograms="selectedPrograms" />
                
            </div>
        </div>
    </div>
    
    <div class="c-single-car-payments__expend-button__wrapper">
        <button class="c-single-car-payments__expend-button" @click="expanded=!expanded" :class="{'-is-active': expanded}">
            <svgIco icon='arrow-down-slim' />
        </button>
    </div>
</div>

</template>

<script>
import { windowObject } from 'is_js';

export default {
    name: 'NewCarPayments',
    data() {
        const out = {
            currentTrim: {},
            loaded: false,
            rebate: 0,
            expanded: false,
            show: 'cash',
            price: null,
            make: null,
            colorcode: null,
            exchange: '',
            includeTaxes: false,
            initial: '',
            cashPriceExpanded: false,
            cashDiscountExpanded: false,
            selectedPrograms: {
                military: false,
                mobility: false,
                graduate: false,
                loyalty: false,                
            },
            term: 'weekly',
            financePriceExpanded: false,
            financeDiscountExpanded: false,
            financeMonths: 0,
            leaseMonths: 0,
            mileage: 0,
            leasePriceExpanded: false,
            leaseDiscountExpanded: false,
        }
        if (window.price) out.price = parseFloat(window.price);
        if (window.make) out.make = window.make;
        if (window.colorcode) out.colorcode = window.colorcode;
        if (window.rebate) out.rebate = parseFloat(window.rebate);
        return out;
    },
    computed: {
        currentRebate() {
            switch(this.show) {
                case 'lease': return this.leaseLines.discountTotal;
                case 'finance': return this.financeLines.discountTotal;
                default: return this.cashLines.discountTotal;
            }
        },
        hasLease() {
            return this.leaseOptions.length > 0;
        },
        termText() {
            switch (this.term) {
                case 'weekly': return 'semaine';
                case 'biweekly': return '2 semaines';
                case 'monthly': return 'mois';
            }
        },
        hasFinance() {
            return this.financeOptions.length > 0;
        },
        rabaisEco() {
            let rabais = this.CSVValue(113);
            if (rabais) return rabais  / 1.14975;
            return 0;
        },
        cashSubtotal() {
            return this.cashLines.priceTotal - this.cashLines.discountTotal - this.exchange;
        },
        cashTotal() {
            return this.cashSubtotal + this.cashTPS + this.cashTVQ;
        },
        cashTPS() {
            return this.includeTaxes ? this.cashSubtotal * 0.05 : 0;
        },
        cashTVQ() {
            return this.includeTaxes ? this.cashSubtotal * 0.09975 : 0;
        },
        colorPrice() {
            let color = this.currentTrim.colors.find(color => color.code == this.colorcode);
            if (color && color.extra) return parseFloat(color.extra);
            return 0;
        },
        currentRow() {
            return this.currentTrim.payments.row;
        },
        cashLines() {
            const out = {
                prices: [
                    {label: this.CSVLine(3), value: this.CSVValue(3)},
                    {label: 'Charge de couleur', value: this.colorPrice},
                    {label: this.CSVLine(4), value: this.CSVValue(4)},
                    {label: this.CSVLine(5), value: this.CSVValue(5)},
                    {label: this.CSVLine(6), value: this.CSVValue(6)},
                    {label: this.CSVLine(7), value: this.CSVValue(7)},
                   // {label: this.CSVLine(8), value: this.CSVValue(8)},
                    {label: this.CSVLine(11), value: this.CSVValue(11)},
                ],
                discounts: [
                    {label: this.CSVLine(16), value: this.CSVValue(16)},
                    {label: this.CSVLine(17), value: this.CSVValue(17)},
                    {label: this.CSVLine(18), value: this.CSVValue(18)},
                ],
                hasEcoRebate: false
            };
            let curPrice = this.CSVValue(14);
            if (this.currentColor.extra) curPrice += parseFloat(this.currentColor.extra);
            if (curPrice > 100000 && this.CSVValue(15)) {
                out.prices.push({label: 'Taxe luxe', value: (curPrice-100000)*.2});
            }
            if (curPrice < this.price) {
                out.prices.push({label: 'Accessoires et options', value: this.price - curPrice});
            }
            if (curPrice > this.price) {
                out.discounts.push({label: 'Autres rabais', value: curPrice - this.price});
            }
            if (this.selectedPrograms.military) {
                out.discounts.push({label: 'Avantage militaire', value: this.CSVValue(115)});
            }
            if (this.selectedPrograms.mobility) {
                out.discounts.push({label: 'Assistance mobilité', value: this.CSVValue(116)});
            }
            if (this.selectedPrograms.graduate) {
                out.discounts.push({label: 'Programme diplômés', value: this.CSVValue(114)});
            }
            if (this.selectedPrograms.loyalty) {
                out.discounts.push({label: 'Réduction fidélité', value: this.CSVValue(117)});
            }
            if (this.rabaisEco > 0) {
                let eco = this.CSVValue(113);
                let rebateName = this.CSVLine(113);
                if (!rebateName) rebateName = 'Rabais EV';
                out.discounts.push({label: rebateName, value: eco});
                out.discounts.push({label: 'Taxes retenues sur '+ rebateName, value: -1*(eco - (eco/1.14975))});
                out.hasEcoRebate = true;
            }
            
            out.priceTotal = out.prices.reduce((acc, line) => acc + line.value, 0);
            out.discountTotal = out.discounts.reduce((acc, line) => acc + line.value, 0);
            return out;
        },
        financeLines() {
            const out = {
                prices: [
                    {label: this.CSVLine(3), value: this.CSVValue(3)},
                    {label: 'Charge de couleur', value: this.colorPrice},
                    {label: this.CSVLine(4), value: this.CSVValue(4)},
                    {label: this.CSVLine(5), value: this.CSVValue(5)},
                    {label: this.CSVLine(6), value: this.CSVValue(6)},
                    {label: this.CSVLine(7), value: this.CSVValue(7)},
                    //{label: this.CSVLine(8), value: this.CSVValue(8)},
                    {label: this.CSVLine(11), value: this.CSVValue(11)},
                ],
                discounts: [
                    {label: 'Rabais financement', value: this.CSVValue(27)},
                ],
                hasEcoRebate: false
            };
            let curPrice = this.CSVValue(14);
            if (this.currentColor.extra) curPrice += parseFloat(this.currentColor.extra);
            if (curPrice > 100000 && this.CSVValue(15)) {
                out.prices.push({label: 'Taxe luxe', value: (curPrice+this.getRDPRM(this.make,'finance')-100000)*.2});
            }
            
            if (curPrice < this.price) {
                out.prices.push({label: 'Accessoires et options', value: this.price - curPrice});
            }
            if (curPrice > this.price) {
                out.discounts.push({label: 'Autres rabais', value: curPrice - this.price});
            }
            if (this.selectedPrograms.military) {
                out.discounts.push({label: 'Avantage militaire', value: this.CSVValue(115)});
            }
            if (this.selectedPrograms.mobility) {
                out.discounts.push({label: 'Assistance mobilité', value: this.CSVValue(116)});
            }
            if (this.selectedPrograms.graduate) {
                out.discounts.push({label: 'Programme diplômés', value: this.CSVValue(114)});
            }
            if (this.selectedPrograms.loyalty && this.CSVValue(119) > 5) {
                out.discounts.push({label: 'Réduction fidélité', value: this.CSVValue(119)});
            }
            if (this.rabaisEco > 0) {
                let eco = this.CSVValue(113);
                let rebateName = this.CSVLine(113);
                if (!rebateName) rebateName = 'Rabais EV';

                out.discounts.push({label: rebateName, value: eco});
                out.discounts.push({label: 'Taxes retenues sur '+ rebateName, value: -1*(eco - (eco/1.14975))});
                out.hasEcoRebate = true;
            }
            out.prices.push({label: this.CSVLine(9), value: this.getRDPRM(make,'finance')});
            out.priceTotal = out.prices.reduce((acc, line) => acc + line.value, 0);
            out.discountTotal = out.discounts.reduce((acc, line) => acc + line.value, 0);
            return out;
        },
        financeOptions() {
            let out = [];
            for (let i = 26;i >= 20;i--) {
                if (this.currentRow[i] == '-%') continue;
                out.push({months: (i-18)*12,rate: this.CSVValue(i)});
            }
            return out;
        },
        financeSubtotal() {
            return this.financeLines.priceTotal - this.financeLines.discountTotal - this.exchange;
        },
        financeTPS() {
            return this.includeTaxes ? this.financeSubtotal * 0.05 : 0;
        },
        financeTVQ() {
            return this.includeTaxes ? this.financeSubtotal * 0.09975 : 0;
        },
        leaseSubtotal() {
            return this.leaseLines.priceTotal - this.leaseLines.discountTotal - this.exchange;
        },
        leaseTPS() {
            return this.includeTaxes ? this.leaseSubtotal * 0.05 : 0;
        },
        leaseTVQ() {
            return this.includeTaxes ? this.leaseSubtotal * 0.09975 : 0;
        },
        financeTotal() {
            let total = this.financeSubtotal + this.financeTPS + this.financeTVQ;
            if (this.initial) total -= parseFloat(this.initial);
            let f = this.financeOptions.find(item => item.months == this.financeMonths)
            let rate = f.rate;
            let months = f.months;
            // Calculate loan per this.term
            if (rate <= 0) rate = 0.000000001;
            if (this.selectedPrograms.loyalty && this.CSVValue(119) < 5) rate -= this.CSVValue(119);

            let interest = parseFloat(rate) / 100 / 12;

            let x = Math.pow(1 + interest, months);
            let monthly = (total * x * interest) / (x - 1);
            if (this.term == 'weekly') return monthly * 12 / 52;
            if (this.term == 'biweekly') return monthly * 12 / 26;
            return monthly;
        },
        leaseOptions() {
            
            let out = [];
            for (let i = 29;i <= 42;i++) {
                if (this.currentRow[i] == '-%') continue;
                let months = 0;
                let residual = this.CSVValue(i+16);
                switch(i) {
                    case 29: months = 24; break;
                    case 30: months = 27; break;
                    case 31: months = 30; break;
                    case 32: months = 33; break;
                    case 33: months = 36; break;
                    case 34: months = 39; break;
                    case 35: months = 42; break;
                    case 36: months = 45; break;
                    case 37: months = 48; break;
                    case 38: months = 51; break;
                    case 39: months = 54; break;
                    case 40: months = 57; break;
                    case 41: months = 60; break;
                    case 42: months = 64; break;
                }
                out.push({months: months,rate: this.CSVValue(i), residual: residual});
            }
            // Reverse the array
            return out.reverse();
        },
        leaseMileage() {
            switch(this.make) {
                case 'Kia': 
                case 'Hyundai':
                case 'Nissan':
                case 'Mazda':
                case 'Volvo':
                case 'Chevrolet':
                case 'GMC':
                case 'Buick':
                    return [
                        {value: 16, label: '16 000 km', discount: 3},
                        {value: 20, label: '20 000 km', discount: 2},
                        {value: 24, label: '24 000 km', discount: 0},
                    ];
                case 'Chrysler':
                case 'Dodge':
                case 'Jeep':
                case 'Ram':
                case 'FIAT':
                case 'Fiat':
                    return [
                        {value: 12, label: '12 000 km', discount: -1},
                        {value: 18, label: '18 000 km', discount: -1},
                        {value: 24, label: '24 000 km', discount: -1},
                    ];

            }
            return [
                {value: 12, label: '12 000 km', discount: -1},
                {value: 18, label: '18 000 km', discount: -1},
                {value: 24, label: '24 000 km', discount: -1},
            ];
        },
        leaseLines() {
            const out = {
                prices: [
                    {label: this.CSVLine(3), value: this.CSVValue(3)},
                    {label: 'Charge de couleur', value: this.colorPrice},
                    {label: this.CSVLine(4), value: this.CSVValue(4)},
                    {label: this.CSVLine(5), value: this.CSVValue(5)},
                    {label: this.CSVLine(6), value: this.CSVValue(6)},
                    {label: this.CSVLine(7), value: this.CSVValue(7)},
                    //{label: this.CSVLine(8), value: this.CSVValue(8)},
                    {label: this.CSVLine(11), value: this.CSVValue(11)},
                ],
                discounts: [
                    {label: 'Rabais location', value: this.CSVValue(43)},
                ],
                hasEcoRebate: false
            };
            let curPrice = this.CSVValue(14);
            
            if (this.currentColor.extra) curPrice += parseFloat(this.currentColor.extra);
            if (curPrice > 100000 && this.CSVValue(15)) {
                out.prices.push({label: 'Taxe luxe', value: (curPrice+this.getRDPRM(this.make,'lease')-100000)*.2});
            }
            if (curPrice < this.price) {
                out.prices.push({label: 'Accessoires et options', value: this.price - curPrice});
            }
            if (curPrice > this.price) {
                out.discounts.push({label: 'Autres rabais', value: curPrice - this.price});
            }
            if (this.selectedPrograms.military) {
                out.discounts.push({label: 'Avantage militaire', value: this.CSVValue(115)});
            }
            if (this.selectedPrograms.mobility) {
                out.discounts.push({label: 'Assistance mobilité', value: this.CSVValue(116)});
            }
            if (this.selectedPrograms.graduate) {
                out.discounts.push({label: 'Programme diplômés', value: this.CSVValue(114)});
            }
            if (this.selectedPrograms.loyalty && this.CSVValue(118) > 5) {
                out.discounts.push({label: 'Réduction fidélité', value: this.CSVValue(118)});
            }
            if (this.rabaisEco > 0) {
                let eco = this.CSVValue(113);
                if (this.leaseMonths < 36) eco = eco * 0.5;
                else if (this.leaseMonths < 48) eco = eco * 0.75;
                let rebateName = this.CSVLine(113);
                if (!rebateName) rebateName = 'Rabais EV';

                out.discounts.push({label: rebateName, value: eco});
                out.discounts.push({label: 'Taxes retenues sur '+ rebateName, value: -1*(eco - (eco/1.14975))});
                out.hasEcoRebate = true;
            }
            out.prices.push({label: this.CSVLine(10), value: this.getRDPRM(make,'lease')});
            out.priceTotal = out.prices.reduce((acc, line) => acc + line.value, 0);
            out.discountTotal = out.discounts.reduce((acc, line) => acc + line.value, 0);
            return out;
        },

        leaseTotal() {
            let selectedMileage = this.leaseMileage.find(item => item.value == this.mileage);
            let selectedOption = this.leaseOptions.find(item => item.months == this.leaseMonths);
            let rate = selectedOption.rate;
            
            let $months = this.leaseMonths;
            let $rabais = this.CSVValue(43);
            if (this.selectedPrograms.military) $rabais += this.CSVValue(115);
            if (this.selectedPrograms.mobility) $rabais += this.CSVValue(116);
            if (this.selectedPrograms.graduate) $rabais += this.CSVValue(114);
            if (this.selectedPrograms.loyalty && this.CSVValue(118) > 5) $rabais += this.CSVValue(118);
            if (this.selectedPrograms.loyalty && this.CSVValue(118) < 5) rate -= this.CSVValue(118);
            let initial = this.initial || 0;
            let exchange = this.exchangeComposed || 0;
            let $mfac = rate / 24 / 100;
            let $rabaiseco = 0;
            let $montantresiduel = 0;
            let $pctres = 0;
            console.log(this.price);
            let $pdsf = this.price;
            let $optionPrice = this.price - this.CSVValue(14);
            if (isNaN($optionPrice)) $optionPrice = 0;
            let rebateName = this.CSVLine(113);
            if (!rebateName) rebateName = 'Rabais EV';
            if (this.leaseLines.hasEcoRebate) $rabaiseco = this.leaseLines.discounts.find(item => item.label == rebateName).value;
            let $payment = 0;
            switch(this.make) {
                case 'Kia': 
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);
                    $montantresiduel = ($D+$E+$F)*($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D+$E+$F)*($pctres / 100)');

                    $payment = (($D+$E+$F+$G+$K+$L+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$K+$L-$rabais+$montantresiduel)*$mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D+$E+$F+$G+$K+$L+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$K+$L-$rabais+$montantresiduel)*$mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$K =', $K, '$L =', $L, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);

                    
                    break;
                case 'Hyundai':
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);
                    $montantresiduel = ($D+$E+$F)*($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D+$E+$F)*($pctres / 100)');

                    $payment = (($D+$E+$F+$G+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G-$rabais+$montantresiduel)*$mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D+$E+$F+$G+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G-$rabais+$montantresiduel)*$mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$K =', $K, '$L =', $L, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);
                    break;
                case 'Nissan':
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $H = this.CSVValue(7);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);
                    $R = this.getRDPRM(this.make,'lease');
                    $montantresiduel = ($D+$E+$F+$G+$H+$L)*($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D+$E+$F+$G+$H+$L)*($pctres / 100)');

                    $payment = (($D+$E+$F+$G+$H+$L+$R+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$H+$L-$rabais+$montantresiduel)*$mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D+$E+$F+$G+$H+$L+$R+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$H+$L-$rabais+$montantresiduel)*$mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$H =', $H, '$L =', $L, '$R =', $R, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);

                    break;
                case 'Mazda':
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $H = this.CSVValue(7);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);
                    $R = this.getRDPRM(this.make,'lease');
                    $montantresiduel = ($D)*($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D)*($pctres / 100)');

                    $payment = (($D+$E+$F+$G+$L+$R+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$L+$R+$rabais+$montantresiduel)*$mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D+$E+$F+$G+$L+$R+$optionPrice-$rabais-$rabaiseco-initial-exchange)-$montantresiduel)/$months+($D+$E+$F+$G+$L+$R+$rabais+$montantresiduel)*$mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$H =', $H, '$L =', $L, '$R =', $R, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);
                    break;
                case 'Volvo':
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $montantresiduel = this.CSVValue(3)*($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = this.CSVValue(3)*($pctres / 100)');

                    $M5 = this.CSVValue(12);
                    $N5 = this.CSVValue(13);
                    $payment = ((($pdsf+$M5+$N5)-$rabais-$montantresiduel-$rabaiseco-initial-exchange)/$months)+(($pdsf+$M5+$N5)-$rabais+$montantresiduel)*$mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = ((($pdsf+$M5+$N5)-$rabais-$montantresiduel-$rabaiseco-initial-exchange)/$months)+(($pdsf+$M5+$N5)-$rabais+$montantresiduel)*$mfac');
                    console.log('$pctres = ', $pctres, '$pdsf =', $pdsf, '$M5 =', $M5, '$N5 =', $N5, '$rabais =', $rabais, '$montantresiduel =', $montantresiduel, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);
                    break;
                case 'Chevrolet':
                case 'GMC':
                case 'Buick':
                    $pctres = selectedOption.residual + selectedMileage.discount;
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $H = this.CSVValue(7);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);
                    $montantresiduel = ($D + $E + $F) * ($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D + $E + $F) * ($pctres / 100)');

                    $payment = (($D + $E + $F +$G + $H + $L + $optionPrice - $rabais - $rabaiseco-initial-exchange) - $montantresiduel) / $months + ($D + $E + $F+ $G + $H + $L - $rabais + $montantresiduel) * $mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D + $E + $F +$G + $H + $L + $optionPrice - $rabais - $rabaiseco-initial-exchange) - $montantresiduel) / $months + ($D + $E + $F+ $G + $H + $L - $rabais + $montantresiduel) * $mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$H =', $H, '$L =', $L, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);
                    
                    break;
                case 'Chrysler':
                case 'Dodge':
                case 'Jeep':
                case 'Ram':
                case 'FIAT':
                case 'Fiat':
                    $pctres = selectedOption.residual;
                    if (this.mileage == 18) {
                        if (this.leaseMonths >= 24 && this.leaseMonths < 48) $pctres = $pctres + 2;
                        if (this.leaseMonths >= 48) $pctres = $pctres + 3;
                    }
                    if (this.mileage == 12) {
                        if (this.leaseMonths >= 24 && this.leaseMonths < 36) $pctres = $pctres + 3;
                        if (this.leaseMonths >= 36 && this.leaseMonths < 48) $pctres = $pctres + 4;
                        if (this.leaseMonths >= 48 && this.leaseMonths < 60) $pctres = $pctres + 5;
                        if (this.leaseMonths >= 60) $pctres = $pctres + 6;
                    }
                    $D = this.CSVValue(3);
                    $E = this.CSVValue(4);
                    $F = this.CSVValue(5);
                    $G = this.CSVValue(6);
                    $K = this.CSVValue(10);
                    $L = this.CSVValue(11);

                    $montantresiduel = ($D + $E + $F) * ($pctres / 100);
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$montantresiduel = ($D + $E + $F) * ($pctres / 100)');

                    $payment = (($D + $E + $F + $optionPrice - $rabais - $rabaiseco-initial-exchange) - $montantresiduel) / $months + ($D + $E + $F - $rabais + $montantresiduel) * $mfac;
                    // Console log the last calculation as a string and every variable in the $payment calculation
                    console.log('$payment = (($D + $E + $F + $optionPrice - $rabais - $rabaiseco-initial-exchange) - $montantresiduel) / $months + ($D + $E + $F - $rabais + $montantresiduel) * $mfac');
                    console.log('$pctres = ', $pctres, '$D =', $D, '$E =', $E, '$F =', $F, '$G =', $G, '$K =', $K, '$L =', $L, '$optionPrice', $optionPrice, '$rabais =', $rabais, '$rabaiseco =', $rabaiseco, 'initial =', initial, 'exchange =', exchange, '$montantresiduel =', $montantresiduel, '$months =', $months, '$mfac =', $mfac, '$payment =', $payment);
            }
            if (this.term == 'weekly') $payment = $payment * 12 / 52;
            if (this.term == 'biweekly') $payment = $payment * 12 / 26;
            if (this.includeTaxes) $payment = $payment * 1.14975;
            return $payment;

        },
        exchangeComposed() {
            return !this.includeTaxes ? parseFloat(this.exchange) : parseFloat(this.exchange) * 1.14975;
        },
        currentColor() {
            let color = this.currentTrim.colors.find(color => color.code == this.colorcode);
            if (color) return color;
            return {extra: 0};
        }

    },
    methods: {
        getRDPRM(make, type) {
            if (type=='finance' && this.CSVValue(9)) return this.CSVValue(9);
            if (type=='lease' && this.CSVValue(10)) return this.CSVValue(10);
            if (make == 'Nissan') {
                if (type == 'finance') {
                    switch (this.financeMonths) {
                        case 24: return 73;
                        case 36: return 76;
                        case 48: return 79;
                        case 60: return 82;
                        case 72: return 82;
                        case 84: return 82;
                    }
                } else {
                    switch(this.leaseMonths) {
                        case 24: return 73;
                        case 30: return 73;
                        case 36: return 76;
                        case 39: return 79;
                        case 48: return 79;
                        case 60: return 82;
                        case 64: return 82;
                    }
                }
            }
            if (make == 'Volvo') {
                if (type == 'finance') {
                    switch (this.financeMonths) {
                        case 24: return 65.93;
                        case 36: return 77.05;
                        case 48: return 87.95;
                        case 60: return 101.62;
                        case 72: return 109.06;
                        case 84: return 116.28;
                    }
                } else {
                    switch(this.leaseMonths) {
                        case 24: return 65.93;
                        case 36: return 77.05;
                        case 39: return 87.95;
                        case 42: return 87.95;
                        case 48: return 87.95;
                    }
                }
            }
            if (make == 'Hyundai') {
                if (type == 'finance') {
                    switch (this.financeMonths) {
                        case 24: return 104;
                        case 36: return 107;
                        case 48: return 110;
                        case 60: return 114;
                        case 72: return 114;
                        case 84: return 114;
                        case 96: return 114;
                    }
                } /*else {
                    switch(this.leaseMonths) {
                        case 24: return 104;
                        case 33: return 107;
                        case 36: return 107;
                        case 48: return 110;
                        case 60: return 114;
                    }
                }*/
            }
            if (make == 'Mazda') {
                if (type == 'finance') {
                    switch (this.financeMonths) {
                        case 24: return 39.6;
                        case 36: return 42.6;
                        case 48: return 45.6;
                        case 60: return 50.6;
                        case 72: return 50.6;
                        case 84: return 50.6;
                    }
                } else {
                    switch(this.leaseMonths) {
                        case 36: return 42.4;
                        case 39: return 42.4;
                        case 42: return 45.4;
                        case 45: return 45.4;
                        case 48: return 45.4;
                        case 51: return 50.4;
                        case 54: return 50.4;
                        case 57: return 50.4;
                        case 60: return 50.4;
                    }
                }
            }
            if (['Chevrolet','GMC','Buick'].includes(make)) {
                if (type == 'finance') {
                    switch (this.financeMonths) {
                        case 36: return 76.05;
                        case 48: return 86.95;
                        case 60: return 99.62;
                        case 72: return 107.06;
                        case 84: return 114.28;
                    }
                } else {
                    switch(this.leaseMonths) {
                        case 24: return 46.21;
                        case 36: return 49.21;
                        case 48: return 52.21;
                        case 60: return 57.21;
                    }
                }
            }
            return 0;
        },
        bind() {
            document.$on('trimChanged', (data) => {
                
                this.currentTrim = data.detail.trim;
                if (!window.price) {
                    let value = this.currentTrim.payments.row[14];
                    value = value.replace(/[^0-9,]/g, '');
                    value = value.replace(',', '.');
                    var colorprice = this.currentColor.extra;
                    if (colorprice == '') colorprice = 0;
                    this.price = parseFloat(value) + parseFloat(colorprice);
                }
                if (this.hasFinance) {
                    this.financeMonths = this.financeOptions[0].months;
                }
                if (this.hasLease) {
                    this.leaseMonths = this.leaseOptions[0].months;
                    this.mileage = this.leaseMileage[0].value;
                }
                if (!this.loaded) {
                    this.findBestLease()
                    this.selectTab();
                }
                this.loaded = true;

            });
            document.$on('rowChanged', (data) => {
                this.currentTrim.payments.row = data.detail.row;
                let value = this.currentTrim.payments.row[14];
                value = value.replace(/[^0-9,]/g, '');
                value = value.replace(',', '.');
                var colorprice = this.currentColor.extra;
                if (colorprice == '') colorprice = 0;
                this.price = parseFloat(value) + parseFloat(colorprice);


            });
            document.$on('colorChanged', (data) => {
                this.colorcode = data.detail.color;
                let value = this.currentTrim.payments.row[14];
                value = value.replace(/[^0-9,]/g, '');
                value = value.replace(',', '.');
                var colorprice = this.currentColor.extra;
                if (colorprice == '') colorprice = 0;
                this.price = parseFloat(value) + parseFloat(colorprice);

            });
        },
        CSVValue(num) {

            let value = this.currentRow[num];
            // Transform 12 000,00$ to a float
            value = value.replace(/[^0-9,]/g, '');
            value = value.replace(',', '.');
            if (value == '') return 0;
            return parseFloat(value);
        },
        CSVLine(num) {
            return this.currentTrim.payments.infos[num];
        },
        findBestLease() {
            let bestMonth = 9999;
            let bestPayment = 9999;
            this.leaseOptions.forEach(option => {
                this.leaseMonths = option.months;
                let payment = this.leaseTotal;
                if (payment < bestPayment) {
                    bestPayment = payment;
                    bestMonth = option.months;
                }
            });
            if (bestMonth != 9999) {
                this.leaseMonths = bestMonth;
            }
        },
        selectTab() {
            if (this.hasFinance && this.hasLease) {
                this.show = this.leaseTotal < this.financeTotal ? 'lease' : 'finance';
                return;
            }
            if (this.hasFinance) {
                this.show = 'finance';
                return;
            }
            if (this.hasLease) {
                this.show = 'lease';
                return;
            }
            this.show = 'cash';
        }
        
    },
    mounted() {
        this.bind();
        
    }
}
</script>